module.exports = __webpack_public_path__ + "media/images/games/35gender/baseballglove-6beb42418eea409d1a3b4694fb9c0ad5.png";